import { AutogenModelEdiCrossReferenceOrderType, AutogenRowEdiCrossReferenceOrderType } from "./autogen/AutogenModelEdiCrossReferenceOrderType";

export class ModelEdiCrossReferenceOrderType extends AutogenModelEdiCrossReferenceOrderType<RowEdiCrossReferenceOrderType> {
	constructor() {
		super(RowEdiCrossReferenceOrderType);
	}
}

export class RowEdiCrossReferenceOrderType extends AutogenRowEdiCrossReferenceOrderType {
}